 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"authentication-authentication-module":"authentication-authentication-module","default~agevolazioni-enasarco-agevolazioni-enasarco-module~ateco-ateco-module~documenti-attivi-docum~15c2b53c":"default~agevolazioni-enasarco-agevolazioni-enasarco-module~ateco-ateco-module~documenti-attivi-docum~15c2b53c","default~agevolazioni-enasarco-agevolazioni-enasarco-module~ateco-ateco-module~documenti-attivi-docum~abdb86c2":"default~agevolazioni-enasarco-agevolazioni-enasarco-module~ateco-ateco-module~documenti-attivi-docum~abdb86c2","default~agevolazioni-enasarco-agevolazioni-enasarco-module~ateco-ateco-module~documenti-attivi-docum~48dbac27":"default~agevolazioni-enasarco-agevolazioni-enasarco-module~ateco-ateco-module~documenti-attivi-docum~48dbac27","default~documenti-attivi-documenti-attivi-module~irpef-irpef-module~main-cassetti-fiscali-da-control~4f546d1e":"default~documenti-attivi-documenti-attivi-module~irpef-irpef-module~main-cassetti-fiscali-da-control~4f546d1e","default~intrastat-intrastat-module~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controll~4e783d6d":"default~intrastat-intrastat-module~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controll~4e783d6d","default~documenti-attivi-documenti-attivi-module~irpef-irpef-module~main-cassetto-fiscale-folder-cas~2dbec4e5":"default~documenti-attivi-documenti-attivi-module~irpef-irpef-module~main-cassetto-fiscale-folder-cas~2dbec4e5","default~intrastat-intrastat-module~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controll~dee0ec6b":"default~intrastat-intrastat-module~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controll~dee0ec6b","default~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module~main-cassetto-fi~ee0307d5":"default~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module~main-cassetto-fi~ee0307d5","default~main-dashboard-dashboard-module~main-emissioni-folder-emissioni-module~main-forfettari-in-re~be722e77":"default~main-dashboard-dashboard-module~main-emissioni-folder-emissioni-module~main-forfettari-in-re~be722e77","default~main-emissioni-folder-emissioni-module~main-forfettari-in-registrazione-folder-forfettari-in~ac2d041c":"default~main-emissioni-folder-emissioni-module~main-forfettari-in-registrazione-folder-forfettari-in~ac2d041c","default~documenti-attivi-documenti-attivi-module~main-forfettari-in-registrazione-folder-forfettari-~6499b4bd":"default~documenti-attivi-documenti-attivi-module~main-forfettari-in-registrazione-folder-forfettari-~6499b4bd","default~main-emissioni-folder-emissioni-module~main-forfettari-in-registrazione-folder-forfettari-in~d857cf12":"default~main-emissioni-folder-emissioni-module~main-forfettari-in-registrazione-folder-forfettari-in~d857cf12","default~documenti-attivi-documenti-attivi-module~main-forfettari-in-registrazione-folder-forfettari-~4afe940f":"default~documenti-attivi-documenti-attivi-module~main-forfettari-in-registrazione-folder-forfettari-~4afe940f","default~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module~main-emissioni-f~213beb46":"default~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module~main-emissioni-f~213beb46","default~main-concordato-preventivo-concordato-preventivo-module~main-emissioni-folder-emissioni-modu~caf386b6":"default~main-concordato-preventivo-concordato-preventivo-module~main-emissioni-folder-emissioni-modu~caf386b6","default~main-emissioni-folder-emissioni-module~main-forfettari-in-registrazione-folder-forfettari-in~5ca327d3":"default~main-emissioni-folder-emissioni-module~main-forfettari-in-registrazione-folder-forfettari-in~5ca327d3","default~main-forfettari-in-registrazione-folder-forfettari-in-registrazione-module~main-forfettario-~0d1572d2":"default~main-forfettari-in-registrazione-folder-forfettari-in-registrazione-module~main-forfettario-~0d1572d2","default~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module~main-forfettari-~3505bbdb":"default~main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module~main-forfettari-~3505bbdb","default~main-concordato-preventivo-concordato-preventivo-module~main-forfettari-in-registrazione-fol~dde8e334":"default~main-concordato-preventivo-concordato-preventivo-module~main-forfettari-in-registrazione-fol~dde8e334","default~main-forfettari-in-registrazione-folder-forfettari-in-registrazione-module~main-forfettario-~a4f1d2cb":"default~main-forfettari-in-registrazione-folder-forfettari-in-registrazione-module~main-forfettario-~a4f1d2cb","default~documenti-forfettari-folder-documenti-forfettari-module~main-forfettari-in-registrazione-fol~d59b361b":"default~documenti-forfettari-folder-documenti-forfettari-module~main-forfettari-in-registrazione-fol~d59b361b","main-forfettari-in-registrazione-folder-forfettari-in-registrazione-module":"main-forfettari-in-registrazione-folder-forfettari-in-registrazione-module","main-inps-inps-module":"main-inps-inps-module","default~main-cassetto-fiscale-folder-cassetto-fiscale-module~main-gestione-ateco-gestione-ateco-modu~5ed03780":"default~main-cassetto-fiscale-folder-cassetto-fiscale-module~main-gestione-ateco-gestione-ateco-modu~5ed03780","main-gestione-ateco-gestione-ateco-module":"main-gestione-ateco-gestione-ateco-module","main-gestione-invii-intrastat-gestione-invii-intrastat-module":"main-gestione-invii-intrastat-gestione-invii-intrastat-module","main-gestione-affiliazioni-gestione-affiliazioni-module":"main-gestione-affiliazioni-gestione-affiliazioni-module","main-gestione-bolli-gestione-bolli-module":"main-gestione-bolli-gestione-bolli-module","main-gestione-invii-f24-gestione-invii-f24-module":"main-gestione-invii-f24-gestione-invii-f24-module","main-concordato-preventivo-concordato-preventivo-module":"main-concordato-preventivo-concordato-preventivo-module","main-dashboard-dashboard-module":"main-dashboard-dashboard-module","main-criticita-criticita-module":"main-criticita-criticita-module","default~inail-inail-module~main-inail-auto-liquidazione-module~parametri-inail-parametri-inail-module":"default~inail-inail-module~main-inail-auto-liquidazione-module~parametri-inail-parametri-inail-module","main-inail-auto-liquidazione-module":"main-inail-auto-liquidazione-module","main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module":"main-cassetti-fiscali-da-controllare-cassetti-fiscali-da-controllare-module","main-ruoli-operatori-folder-ruoli-operatori-module":"main-ruoli-operatori-folder-ruoli-operatori-module","main-importazioni-storico-da-enti-importazioni-storico-da-enti-module":"main-importazioni-storico-da-enti-importazioni-storico-da-enti-module","main-cassetto-fiscale-folder-cassetto-fiscale-module":"main-cassetto-fiscale-folder-cassetto-fiscale-module","main-fatturazione-elettronica-fatturazione-elettronica-module":"main-fatturazione-elettronica-fatturazione-elettronica-module","main-fnc-fnc-module":"main-fnc-fnc-module","main-gestione-tabelle-gestione-tabelle-module":"main-gestione-tabelle-gestione-tabelle-module","main-scadenziario-fiscale-scadenziario-fiscale-module":"main-scadenziario-fiscale-scadenziario-fiscale-module","agenzia-entrate-riscossione-agenzia-entrate-riscossione-module":"agenzia-entrate-riscossione-agenzia-entrate-riscossione-module","default~agevolazioni-enasarco-agevolazioni-enasarco-module~enti-creditori-enti-creditori-module~fatt~57fd45be":"default~agevolazioni-enasarco-agevolazioni-enasarco-module~enti-creditori-enti-creditori-module~fatt~57fd45be","fatture-fatture-module":"fatture-fatture-module","documenti-forfettari-folder-documenti-forfettari-module":"documenti-forfettari-folder-documenti-forfettari-module","inail-inail-module":"inail-inail-module","registrazione-apertura-partita-iva-registrazione-apertura-partita-iva-module":"registrazione-apertura-partita-iva-registrazione-apertura-partita-iva-module","registrazione-spid-registrazione-spid-module":"registrazione-spid-registrazione-spid-module","common":"common","invii-sdi-invii-sdi-module":"invii-sdi-invii-sdi-module","documenti-attivi-documenti-attivi-module":"documenti-attivi-documenti-attivi-module","camera-di-commercio-camera-di-commercio-module":"camera-di-commercio-camera-di-commercio-module","ateco-ateco-module":"ateco-ateco-module","enti-creditori-enti-creditori-module":"enti-creditori-enti-creditori-module","tabella-classificazione-costi-tabella-classificazione-costi-module":"tabella-classificazione-costi-tabella-classificazione-costi-module","tabella-contribuzioni-tabella-contribuzioni-module":"tabella-contribuzioni-tabella-contribuzioni-module","irpef-irpef-module":"irpef-irpef-module","intrastat-intrastat-module":"intrastat-intrastat-module","enasarco-enasarco-module":"enasarco-enasarco-module","parametri-parametri-module":"parametri-parametri-module","importi-diritto-camerale-importi-diritto-camerale-module":"importi-diritto-camerale-importi-diritto-camerale-module","agevolazioni-enasarco-agevolazioni-enasarco-module":"agevolazioni-enasarco-agevolazioni-enasarco-module","parametri-enasarco-parametri-enasarco-module":"parametri-enasarco-parametri-enasarco-module","parametri-generali-parametri-generali-module":"parametri-generali-parametri-generali-module","parametri-rate-parametri-rate-module":"parametri-rate-parametri-rate-module","parametri-inail-parametri-inail-module":"parametri-inail-parametri-inail-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
